import { SkeletonFirmaElectronica } from "components/componentesGenerales/skeletonComponents/skeletonFirmaElectronica";
import { DetalleFirma } from "components/solicitudFirma/detalleFirma";
import { SolicitudStatus } from "components/solicitudFirma/solicitudStatus";
import { useSolicitudesFirmaStore } from "hooks/useSolicitudesFirmaStore";
import { useUiStore } from "hooks/useUiStore";
import { InvitadoLayout } from "layouts/invitado/invitadoLayout";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetRecuperarInfSolicitudMutation } from "services/solicitudFirmaService/solicitudFirmaService";
import ImageNotFound from "assets/images/not-found.svg";

const SolicitudFirmasScreen = () => {
  const [searchParam] = useSearchParams();
  const [getRecuperarInfSolicitud, { data: dataSolicitudFirma, error }] =
    useGetRecuperarInfSolicitudMutation();
  const { addDataSolicitudFirma } = useSolicitudesFirmaStore();

  const { showSkeleton, showSkeletonAnimation } = useUiStore();

  useEffect(() => {
    showSkeletonAnimation(true);
    setTimeout(() => {
      showSkeletonAnimation(false);
    }, 2500);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (searchParam.get("key")) {
      const llaveFirma = searchParam.get("key");
      getRecuperarInfSolicitud({
        llaveFirma,
      })
        .unwrap()
        .then(({ data }) => {
          addDataSolicitudFirma(data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line
  }, [searchParam.get("key")]);

  return (
    <InvitadoLayout>
      {showSkeleton ? (
        <SkeletonFirmaElectronica />
      ) : dataSolicitudFirma ? (
        <DetalleFirma />
      ) : error ? (
        <SolicitudStatus
          image={ImageNotFound}
          text="¡Lo sentimos! La solicitud de firma puede que ya no esta vigente :("
        />
      ) : null}
    </InvitadoLayout>
  );
};

export default SolicitudFirmasScreen;
